// @ts-nocheck

import memoize from 'memoize-state';

import getSystemTitle from '../../../utils/getSystemTitle';

import { getBetslipFromProps } from './common';

export const systemHeaderSelector = memoize((state, props) => {
  const betslip = getBetslipFromProps(state, props);
  const { details, cnp } = betslip;
  const combinations = cnp && cnp.map((x) => getSystemTitle(details.length, betslip.bankers.length, x));
  return { combinations };
});
